import type { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import getRealDate from '@sdk/utils/getRealDate';
import { OnboardingTrialStepsType } from '@sdk/authentication/types';

const ONBOARDING_CHECKLIST_ACTIVATION_DATE = '2021-09-28T00:00:00';

export const shouldShowOnboardingChecklist = (
  currentUser: AuthUserType,
  availableSteps: OnboardingTrialStepsType[]
): boolean => {
  if (!currentUser || !currentUser.settings.clientFlags) {
    return false;
  }

  const { isOrgCreator, settings, org } = currentUser;

  // show onboarding checklist when the initial onboarding is complete
  if (!settings.clientFlags.onboarding.finished) {
    return false;
  }

  /**
   * Set of clientFlags that are only those around onboarding trial.
   */
  const onboardingTrial = Object.keys(settings.clientFlags).reduce((acc, flag) => {
    if (flag.startsWith('onboardingTrial_')) {
      acc[flag] = settings.clientFlags[flag];
    }
    return acc;
  }, {});

  /**
   * Array of steps that user have in clientFlags.
   */
  const trackedOnboardingTrialSteps = Object.keys(onboardingTrial);

  if (!Object.keys(onboardingTrial).length) {
    // If onboardingTrial steps are not prepare we're not ready yet to display onboarding checklist
    return false;
  }

  const { createdAt, isOnTrial } = org;
  const orgCreationDate = getRealDate(createdAt);
  const onboardingLiveDate = getRealDate(ONBOARDING_CHECKLIST_ACTIVATION_DATE);
  const isOrgQualified = onboardingLiveDate <= orgCreationDate;

  const hasCompletedOnboarding =
    trackedOnboardingTrialSteps.length >= availableSteps.length &&
    availableSteps.every((step) => Boolean(onboardingTrial[step]?.completed));

  return Boolean(isOrgCreator && isOnTrial && isOrgQualified && !hasCompletedOnboarding);
};
